<template>
  <div>
    <a-dropdown v-if="$slots.button.length > 1">
      <a class="ant-dropdown-link" @click="e => e.preventDefault()">
        <!-- <more-icon style="width: 30px; height:auto"></more-icon> -->
        <a-icon type="menu" style="width: 30px; height:auto"/>
      </a>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, index) in $slots.button" :key="index">
          <render :node="item"></render>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <div v-else class="single-button">
      <slot name="button"></slot>
    </div>
  </div>
</template>

<script>
// import MoreIcon from '@/assets/svg/more.svg'
const Render = {
  props: {
    node: Object
  },
  render() {
    return this.$props.node
  }
}
export default {
  name: "CollapseButtons",
  components: {
    Render,
    // MoreIcon
  }
}
</script>

<style lang="scss" scoped>
  .single-button /deep/ .ant-btn {
    padding: 0;
  }
</style>
